import { FC } from 'react';

import Box from '@mui/material/Box';
import { CriteriaTypeTab, RuleTab, RuleTemplateTab } from './components';
import { SCUITabs } from '../../../../atomic/atoms';

import { useRuleService } from '../../context/RuleServiceContext';
import { getTabConfig } from '../../helper/RuleServiceV2.const';
import { RST } from './ruleTabs.classes';

export const RuleTabs: FC<any> = () => {
    const { activeTab, setActiveTab, clearRuleData } = useRuleService();

    const handleChangeTabs = (_: any, activeTabIndex: number): void => {
        setActiveTab(activeTabIndex);
        clearRuleData();
    };

    return (
        <Box className={RST.root} sx={{ padding: '16px' }}>
            <div className={RST.tabsWrap}>
                <SCUITabs tabList={getTabConfig()} onChange={handleChangeTabs} activeTabIndex={activeTab} />
            </div>
            <div className={RST.tabPanel}>
                {activeTab === 0 && <CriteriaTypeTab />}
                {activeTab === 1 && <RuleTemplateTab />}
                {activeTab === 2 && <RuleTab />}
            </div>
        </Box>
    );
};
